import React from "react";

export const InvoiceDraw = () => {
    return (
        <div>tt</div>
    )
}

